import { inject, Injectable } from '@angular/core';
import { assertGraphqlDataNode, type OfType } from '@reconcept-platform/shared/data-access';
import {
  type DashboardFormatsQueryQuery,
  type DashboardFormatsQueryQueryVariables,
  type DashboardFormatWithDashboardsAndWorkspacesQuery,
  type DashboardFormatWithDashboardsAndWorkspacesQueryVariables,
  type UpdateDashboardFormatMutation,
  type UpdateDashboardFormatMutationVariables,
} from '@reconcept-platform/shared/types';
import { gql } from 'apollo-angular';
import { map } from 'rxjs/operators';
import { WorkspaceGraphQLService } from '../../workspace-graphql.service';
import { dashboardFormatsQuery, dashboardFormatWithDashboardsAndWorkspacesQuery } from './dashboard-format.queries';

export type DashboardFormatsQueryQuery_DashboardFormat =
  // @ts-expect-error TS2339 property does not exist
  DashboardFormatsQueryQuery['dashboardFormats']['nodes'][number];

export type DashboardFormatWithDashboardsAndWorkspacesQuery_DashboardFormat = OfType<
  // @ts-expect-error TS2344 type constraint not satisfied
  DashboardFormatWithDashboardsAndWorkspacesQuery['node'],
  'DashboardFormat'
>;
export type DashboardFormatWithDashboardsAndWorkspacesQuery_Dashboard =
  DashboardFormatWithDashboardsAndWorkspacesQuery_DashboardFormat['dashboards']['nodes'][number];

@Injectable({
  providedIn: 'root',
})
export class DashboardFormatApi {
  private workspaceGraphQLService = inject(WorkspaceGraphQLService);

  watchDashboardFormats() {
    return (
      this.workspaceGraphQLService
        .watchQuery<DashboardFormatsQueryQuery, DashboardFormatsQueryQueryVariables>({
          query: dashboardFormatsQuery,
        })
        // @ts-expect-error TS18049 possibly null or undefined
        .pipe(map((result) => result.data.dashboardFormats.nodes))
    );
  }

  watchDashboardFormatWithDashboards(id: string) {
    return this.workspaceGraphQLService
      .watchQuery<
        DashboardFormatWithDashboardsAndWorkspacesQuery,
        DashboardFormatWithDashboardsAndWorkspacesQueryVariables
      >({
        query: dashboardFormatWithDashboardsAndWorkspacesQuery,
        variables: {
          id,
        },
      })
      .pipe(map((result) => assertGraphqlDataNode(result, 'DashboardFormat')));
  }

  updateDashboardFormat(
    dashboardFormatId: string,
    value: {
      title: string | null;
    },
  ) {
    return (
      this.workspaceGraphQLService
        .mutateV2<UpdateDashboardFormatMutation, UpdateDashboardFormatMutationVariables>({
          mutation: gql`
            mutation UpdateDashboardFormat($input: UpdateDashboardFormatInput!) {
              updateDashboardFormat(input: $input) {
                dashboardFormat {
                  id
                  title
                }

                errors {
                  message
                  path
                }
              }
            }
          `,
          variables: {
            input: {
              dashboardFormatId,
              ...value,
            },
          },
        })
        // @ts-expect-error TS18048 possibly undefined | TS18049 possibly null or undefined
        .pipe(map((result) => result.data.updateDashboardFormat.dashboardFormat))
    );
  }
}
